import { ConnectionDetails, convertConnectionToDetails, mergeConnectionDetails as merge } from '@/utils/custom';
import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DispatchIssueDocument,
  DispatchIssueDocumentSearch,
  SearchDispatchIssueDocumentResponseDispatchIssueDocumentConnectionArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { SearchDispatchIssueDocument } from '@/features/IssueHistory/api/queries/SearchDispatchIssueDocument';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DispatchIssueDocumentSearch]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<DispatchIssueDocument>>;
}

// SearchDispatchIssueDocument Service
export const { searchDispatchIssueDocument, refetchDispatchIssueDocument, useDispatchIssueDocument } = ((): {
  searchDispatchIssueDocument: ServiceMethod;
  refetchDispatchIssueDocument: ServiceMethod;
  useDispatchIssueDocument: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch, refetch] = graphApi(SearchDispatchIssueDocument).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<ConnectionDetails<DispatchIssueDocument>> => {
        const args: SearchDispatchIssueDocumentResponseDispatchIssueDocumentConnectionArgs = {
          input: {
            first: options?.pageSize || null,
            after: options?.pageSize > 0 ? (options?.pageSize * options?.page).toString() : null,
            query: payload,
          },
        };
        const opts = { merge: options?.merge ? 'searchDispatchIssueDocument.dispatchIssueDocumentConnection' : undefined };
        const res = await fn(args, opts);
        return convertConnectionToDetails(getProperty('searchDispatchIssueDocument.dispatchIssueDocumentConnection', res));
      }
  );
  const useService = createGraphApiHook(fetch, { refetch, merge });
  return {
    searchDispatchIssueDocument: fetch,
    refetchDispatchIssueDocument: refetch,
    useDispatchIssueDocument: useService,
  };
})();
